import React from 'react'
import { Settings02Icon } from 'src/editor/shared/icons/settings-02-icon'
import { Trash02Icon } from 'src/editor/shared/icons/trash-02-icon'
import {
  ButtonSizeEnum,
  GrayIconButton,
} from 'src/editor/shared/ui-lib/buttons'

export interface PopupItemProps {
  id: string
  title: string
  display: (id: string) => void
  remove: (id: string) => void
}

export const PopupItem = ({ remove, id, display, title }: PopupItemProps) => {
  const onDisplayClick = () => display(id)
  const onRemoveClick = () => remove(id)

  return (
    <div className="flex justify-between rounded-md bg-bgSecondary p-1.5 text-M">
      <span className="flex max-w-[190px] items-center overflow-hidden text-ellipsis whitespace-nowrap break-all">
        {title}
      </span>
      <div className="flex items-center">
        <GrayIconButton
          size={ButtonSizeEnum.Small}
          icon={<Settings02Icon />}
          onClick={onDisplayClick}
        />
        <GrayIconButton
          size={ButtonSizeEnum.Small}
          icon={<Trash02Icon className="text-textPrimary" />}
          onClick={onRemoveClick}
        />
      </div>
    </div>
  )
}
